"use strict";
var ApiFlight = (function () {
    function ApiFlight() {
    }
    return ApiFlight;
}());
exports.ApiFlight = ApiFlight;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-flight.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-flight.model.js